import React from 'react';
import memoize from 'memoize-one';

const TalentDncColumns = memoize(() => [
  {
    name: 'TEMA',
    selector: 'topic',
    cell: item => item.topic?.label || item.topicName,
    sortable: true,
    grow: '2'
  },
  {
    name: 'NECESIDAD',
    selector: 'necessityArea',
    cell: item => item.necessityArea?.label || item.necessityAreaName,
    sortable: true,
    grow: '2'
  },
  {
    name: 'NIVEL DE PROFUNDIDAD',
    selector: 'depthLevel',
    cell: item => item.translatedDepthLevel || item.depthLevel,
    sortable: true,
    grow: '1'
  },
  {
    name: 'NIVEL DE URGENCIA',
    selector: 'urgencyLevel',
    cell: item => item.translatedUrgencyLevel || item.urgencyLevel,
    sortable: true,
    grow: '1'
  },
  {
    name: 'ADMISION',
    selector: 'status',
    cell: item => (
      <p className={`mt-3 text-${item.status === 'approved' ? 'primary' : 'warning'}`}>
        {item.status === 'approved' ? 'Admitido' : item.translatedStatus || 'Pendiente'}
      </p>
    ),
    sortable: true,
    grow: '1'
  },
  {
    name: 'ESTADO',
    selector: 'trainingStatus',
    cell: item => item.translatedTrainingStatus || item.courseStatus || 'No Comenzado',
    sortable: true,
    grow: '1'
  }
]);

export default TalentDncColumns;
